import React, { useState } from "react";

const apiKeyForm = process.env.REACT_APP_FORMSUBMIT;

const SERVICES = [
  "Site Development",
  "Stormwater management",
  "Feasibility & Environmental",
  "Surveying Services",
];

export default function ServicesContactForm() {
  const [form, setForm] = useState({
    full_name: "",
    email: "",
    phone: "",
    services: [],
    message: "",

  });
  // console.log(form);
  // console.log(`EMAIL = ${apiKeyForm}`);

  const onChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "services[]") {
      setForm((f) => {
        const next = checked
          ? [...f.services, value]
          : f.services.filter((v) => v !== value);
        return { ...f, services: next };
      });
      return;
    }
    setForm((f) => ({ ...f, [name]: value }));
  };

  const ServiceCheckbox = ({ label, index }) => {
    const checked = form.services.includes(label);
    return (
      <label
        key={index}
        className={`flex items-center gap-3 rounded-xl border px-4 py-3 cursor-pointer transition
          ${checked ? "border-blue-400 bg-blue-400/10" : "border-gray-700 hover:border-gray-500"}
          text-sm sm:text-base`}
      >
        <input
          type="checkbox"
          name="services[]"
          value={label}
          checked={checked}
          onChange={onChange}
          className="h-5 w-5 accent-blue-500"
        />
        <span className="leading-tight">{label}</span>
      </label>
    );
  };

  return (
    <section className="bg-primario text-secundario">
      <div className="mx-auto max-w-6xl">

        <div className="grid gap-8 lg:grid-cols-2 items-stretch">
          {/* Tarjeta visual lateral */}
          <div className="hidden relative rounded-2xl border border-gray-800 bg-primario p-6 sm:p-8 overflow-hidden min-h-[320px] md:min-h-[420px] lg:min-h-[520px] lg:block">
            <img
              src="https://innovativeld.com/assets/contact-us.webp"
              alt="Contact our team to schedule a complimentary consultation and discuss how our streamlined land development approach can benefit your upcoming projects."
              className="absolute inset-0 h-full w-full object-cover object-center opacity-35 sm:opacity-40"
            />
            <div className="absolute inset-0 p-6 sm:p-8 md:p-10 backdrop-blur-sm bg-primario/40 flex flex-col justify-center">
              <h2 className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold font-primaria leading-tight">
                Ready to get started?
              </h2>
              <p className="mt-4 sm:mt-6 text-base sm:text-lg text-secundario/90 max-w-prose">
                Contact our team to schedule a complimentary consultation and
                discuss how our streamlined land development approach can
                benefit your upcoming projects.
              </p>
            </div>
          </div>

          {/* Formulario (POST clásico) */}
          <form
            className="rounded-2xl border border-gray-800 bg-gray-900/70 backdrop-blur-sm shadow-xl w-full"
            action={`https://formsubmit.co/${apiKeyForm}`}
            method="POST"
          >
            {/* Config FormSubmit */}
            <input type="hidden" name="_captcha" value="false" />
            <input type="hidden" name="_template" value="table" />
            <input
              type="hidden"
              name="_subject"
              value="New consultation (Services)"
            />
            <input
              type="hidden"
              name="_next"
              value="https://innovativeld.com/thanks"
            />
            {/* Honeypot anti-bots */}
            <input className="hidden" type="text" name="_honey" />

            <div className="grid gap-5 p-6 sm:p-8">
              <div>
                <label className="block text-sm sm:text-base mb-1">Full name</label>
                <input
                  className="w-full rounded-xl bg-gray-950 border border-gray-700 px-4 py-3 outline-none focus:ring-2 focus:ring-blue-400 text-secundario placeholder:text-secundario/60"
                  name="full_name"
                  value={form.full_name}
                  onChange={onChange}
                  placeholder="John Doe"
                  required
                />
              </div>

              <div className="grid gap-5 sm:grid-cols-2">
                <div>
                  <label className="block text-sm sm:text-base mb-1">Email</label>
                  <input
                    type="email"
                    className="w-full rounded-xl bg-gray-950 border border-gray-700 px-4 py-3 outline-none focus:ring-2 focus:ring-blue-400 text-secundario placeholder:text-secundario/60"
                    name="email"
                    value={form.email}
                    onChange={onChange}
                    placeholder="your@email.com"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm sm:text-base mb-1">Contact number</label>
                  <input
                    type="tel"
                    className="w-full rounded-xl bg-gray-950 border border-gray-700 px-4 py-3 outline-none focus:ring-2 focus:ring-blue-400 text-secundario placeholder:text-secundario/60"
                    name="phone"
                    value={form.phone}
                    onChange={onChange}
                    placeholder="+1 555 123 4567"
                    required
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm sm:text-base mb-2">
                  Services of interest
                </label>
                <div className="grid sm:grid-cols-2 gap-3">
                  {SERVICES.map((s, i) => (
                    <ServiceCheckbox key={s} label={s} index={i} />
                  ))}
                </div>
              </div>

              <div>
                <label className="block text-sm sm:text-base mb-1">Message</label>
                <textarea
                  name="message"
                  value={form.message}
                  onChange={onChange}
                  rows="5"
                  className="w-full rounded-xl bg-gray-950 border border-gray-700 px-4 py-3 outline-none focus:ring-2 focus:ring-blue-400 resize-y text-secundario placeholder:text-secundario/60"
                  placeholder="Tell us about your project, timeline, budget, or any questions you have."
                  required
                />
              </div>

              <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-end gap-3 pt-2">
                <button
                  type="submit"
                  className="w-full sm:w-auto inline-flex items-center justify-center px-5 py-3 rounded-xl bg-gray-400 text-primario font-semibold hover:bg-secundario transition"
                >
                  Send Request
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}
